export default __webpack_public_path__ + "static/media/sbct-front.fd81a6de.jpg";